import apiClient from './apiClient';
import {
  DeveloperUser,
  CreateDeveloperUserRequest,
  UpdateDeveloperUserRequest,
  SetDeveloperUserPasswordRequest,
} from '../types/DeveloperUser';

export const developerUserApi = {
  getAll: async (): Promise<DeveloperUser[]> => {
    const response = await apiClient.get<DeveloperUser[]>('/api/developerusers');
    return response.data;
  },

  create: async (user: CreateDeveloperUserRequest): Promise<DeveloperUser> => {
    const response = await apiClient.post<DeveloperUser>('/api/developerusers', user);
    return response.data;
  },

  update: async (id: number, user: UpdateDeveloperUserRequest): Promise<DeveloperUser> => {
    const response = await apiClient.put<DeveloperUser>(`/api/developerusers/${id}`, user);
    return response.data;
  },

  setPassword: async (id: number, request: SetDeveloperUserPasswordRequest): Promise<void> => {
    await apiClient.put(`/api/developerusers/${id}/password`, request);
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/developerusers/${id}`);
  },
};
